// extracted by mini-css-extract-plugin
module.exports = {"button":"AddToBasketButton_button__3myaD","nonPremiumButton":"AddToBasketButton_nonPremiumButton__6HWt0"};